import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { deleteSeriesCarting } from "../api/deleteSeriesCarting";

export const useDeleteSeriesCarting = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteSeriesCarting(id),
    onSuccess: () => {
      toast.success("Deleted successfully.");
      queryClient.invalidateQueries({ queryKey: ["allSeriesCarting"] });
    },
    onError: () => {
      toast.error("Failed to delete. Please try again.");
    },
  });
};

